<template>
  <div class="main-content feedback">
    <div class="main-content-heading">
      <h1>Hodnotíte {{ evaluatedName }} - Online spätná väzba</h1>
      <div class="back">
        <a @click="$router.go(-1)">&lt; Späť</a>
      </div>
    </div>
    <div class="heading-spliter"></div>
    <div class="text-mute">
      Pre každú z nižšie uvedených otázok vyberte odpoveď, ktorá z Vášho pohľadu
      najlepšie vystihuje danú vlastnosť hodnotenej osoby. Ak nechcete na danú
      otázku odpovedať, vyberte hodnotu n/a (neviem posúdiť). Pre uloženie
      dotazníka s možnosťou neskoršej úpravy použite tlačidlo "Uložiť
      rozpracované zmeny" a pre odoslanie dotazníka tlačidlo "Uložiť a odoslať
      dotazník". Po odoslaní už nie je možné odpovede akokoľvek meniť.
    </div>
    <v-tabs v-if="areas && areas.length > 0" class="nav-bar-box" show-arrows>
      <v-tab
        max="150"
        v-for="(area, area_id) in areas"
        class="menu-item"
        :class="{ active: site == area.id }"
        @click="(site = area.id), updateArea(area.id)"
        :key="area_id"
        >{{ area.name }}</v-tab
      >
    </v-tabs>
    <div v-else>
      <h2>Ku kurzu nie sú vytvorené žiadne oblasti prieskumu</h2>
    </div>
    <div class="hint text-mute" v-for="(area, area_id) in areas" :key="area_id">
      <p v-if="site == area.id">{{ area.hint }}</p>
    </div>
    <div v-if="site">
      <div v-if="questionArea.question.length > 0">
        <div v-for="question in questionArea.question" :key="question.id">
          <div
            class="main-content-box slider input-box"
            v-if="question.type == 'scale'"
          >
            <div class="question-box">
              <div class="question-text">
                <h4 :class="{ inactive: isDisabled(question.id) == true }">
                  {{ getQuestionText(question) }}
                </h4>
              </div>
              <div class="">
                <app-radio-select
                  class="slider"
                  min="1"
                  :max="question.scale_end"
                  :step="1"
                  :disabled="isDisabled(question.id)"
                  v-model="answers[question.id]"
                  :arr="question.scale"
                ></app-radio-select>
              </div>
            </div>
            <div class="switch">
              <app-switch
                :f-v="$v"
                f-name="yesNo"
                label="N/A"
                v-model="NA[question.id]"
              ></app-switch>
            </div>
          </div>
          <div
            class="main-content-box slider input-box"
            v-if="question.type == 'switch'"
          >
            <div class="question-box">
              <div class="question-text">
                <h4 :class="{ inactive: isDisabled(question.id) == true }">
                  {{ getQuestionText(question) }}
                </h4>
              </div>
              <div class="">
                <app-yes-no-switch
                  :class="{ inactive: isDisabled(question.id) == true }"
                  :disabled="isDisabled(question.id)"
                  :f-v="$v"
                  labelYes="Ano"
                  labelNo="Nie"
                  f-name="yesNo"
                  v-model="answers[question.id]"
                ></app-yes-no-switch>
              </div>
            </div>
            <div class="switch">
              <app-switch
                :f-v="$v"
                f-name="yesNo"
                label="N/A"
                v-model="NA[question.id]"
              ></app-switch>
            </div>
          </div>
          <div
            class="main-content-box slider input-box"
            v-if="question.type == 'free'"
          >
            <div class="question-box">
              <div class="question-text">
                <h4 :class="{ inactive: isDisabled(question.id) == true }">
                  {{ getQuestionText(question) }}
                </h4>
              </div>
              <div class="center">
                <app-textarea
                  :class="{ inactive: isDisabled(question.id) == true }"
                  :disabled="isDisabled(question.id)"
                  class="input"
                  :f-v="$v"
                  f-name="freeAnswer"
                  label="Odpoveď"
                  v-model="answers[question.id]"
                ></app-textarea>
              </div>
            </div>
            <div class="switch">
              <app-switch
                :f-v="$v"
                f-name="yesNo"
                label="N/A"
                v-model="NA[question.id]"
              ></app-switch>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <h2>V rámci oblasti nie sú vytvorené žiadne otázky</h2>
      </div>
      <div class="buttons">
        <div class="save-button white-button">
          <a class="button empty" @click="saveQuestions"
            >Uložiť rozpracované zmeny ></a
          >
        </div>
        <div class="save-button">
          <a class="button" @click="saveQuestions"
            >Uložiť a odoslať dotazník ></a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.hint {
  margin: 0.1em 1.2em 0.1em 1.2em;
}
</style>

<script>
import RangeSlider from "vue-range-slider";
import FormBase from "@/public_app/elements/FormBase";
import { required, requiredIf, email, sameAs } from "vuelidate/lib/validators";

export default {
  props: ["courseId", "relationId", "evaluatedName", "roleId"],
  components: {
    RangeSlider,
  },
  mixins: [FormBase],
  data() {
    return {
      answers: {},
      NA: [],
      currentLang: null,
      dbAnswers: null,
      questionLists: null,
      questionArea: null,
      areas: null,
      courses: null,
      site: null,
    };
  },
  mounted() {},
  created() {
    this.refresh();
  },
  methods: {
    getQuestionText(question) {
      //console.log(question);
      let questionText = question.text;
      question.role_texts.forEach((text) => {
        if (question.one_text == 0) {
          if (text.role_id == this.roleId && text.lang_id == this.currentLang) {
            questionText = text.text;
          }
        } else if (question.one_text == 1) {
          if (text.role_id == null && text.lang_id == this.currentLang) {
            questionText = text.text;
          }
        }
      });
      return questionText;
    },
    isDisabled(questionId) {
      if (this.NA[questionId] == true) {
        return true;
      } else {
        return false;
      }
    },
    getQuestionTypes() {
      if (this.questionLists.length > 0) {
        let questionTypes = {};
        this.questionLists.forEach((area) => {
          if (area.question.length > 0) {
            area.question.forEach((e) => {
              questionTypes[e.id] = e.type;
            });
          }
        });
        return questionTypes;
      } else {
        return "Empty question list";
      }
    },
    saveQuestions() {
      this.$v.$touch();
      this.loading1 = true;
      this.$api.helpers.sendForm(this.$v, (res) => {
        if (res) {
          // If valid
          let formatedAnswers = [];
          let questionTypes = this.getQuestionTypes();
          for (var k in this.answers) {
            let questionLine = {};
            let hasNA = false;
            // Add answer in formatedAnswers array
            if (this.answers.hasOwnProperty(k)) {
              if (this.answers[k] !== null) {
                questionLine = {
                  questionId: k,
                  answer: this.answers[k],
                };
              } else {
                questionLine = { questionId: k, answer: null };
              }
              for (var qK in questionTypes) {
                if (k == qK) {
                  questionLine.type = questionTypes[qK];
                }
              }
              for (var kNA in this.NA) {
                // Check if answer is in NA array
                if (this.NA.hasOwnProperty(kNA)) {
                  if (kNA == k && this.NA[kNA] == true) {
                    hasNA = true;
                  }
                }
                if (hasNA == true) {
                  questionLine.NA = true;
                } else {
                  questionLine.NA = false;
                }
              }
              formatedAnswers.push(questionLine);
            }

            for (var kNA in this.NA) {
              questionLine = { questionId: kNA, answer: null };
              let f = false;
              for (let i in formatedAnswers) {
                if (formatedAnswers[i].questionId == kNA) {
                  f = true;
                }
              }
              if (f == false && this.NA[kNA]) {
                for (var qK in questionTypes) {
                  if (kNA == qK) {
                    questionLine.type = questionTypes[qK];
                  }
                }
                questionLine.NA = true;
                formatedAnswers.push(questionLine);
              }
            }
          }

          this.$api.server
            .post("api/public/feedback/answers/save", {
              courseId: this.courseId,
              relationId: this.relationId,
              answers: formatedAnswers,
              lang_id: this.currentLang,
            })
            .then((r) => {
              this.$api.bus.trigger(
                "course-status-change",
                this.courseId,
                r.data.progress
              );
              this.$api.toaster.success({
                txt: "Otázky uložené!",
              });
            });
        } else {
          // If not valid
          this.$api.toaster.fail({
            txt: "Nie sú vyplnené všetky otázky!",
          });
          this.loading1 = false;
        }
      });
    },
    yesNoLabel(answer) {
      return answer == true ? "Áno" : "Nie";
    },
    updateArea(areaId) {
      this.questionLists.forEach((e) => {
        if (e.id == areaId) {
          this.questionArea = e;
        }
      });
    },
    refresh() {
      this.currentLang = this.$api.translator.getCurrent();
      this.$api.server
        .get("api/public/feedback/areas/" + this.courseId)
        .then((r) => {
          this.areas = r.data;
        });

      this.$api.server
        .get("api/public/feedback/questions/" + this.courseId)
        .then((r) => {
          this.questionLists = r.data;
          this.updateArea(this.areas[0].id);
          this.site = this.areas[0].id;
        });

      this.$api.server
        .get("api/public/feedback/answers/" + this.relationId)
        .then((r) => {
          this.dbAnswers = r.data;
          r.data.forEach((e) => {
            this.answers[e.question_id] = e.answer;

            if (e.type == "switch") {
              this.answers[e.question_id] = e.answer == "1";
            }
            // Update Model
            //this.answers.push({});
            //this.answers.splice(this.answers.length - 1, 1);

            this.NA[e.question_id] = e.NA == 1 ? true : false;
          });
        });
    },
    navigateTo(v) {
      // if (!v) {
      //     this.$router.push({name: "Dashboard"});
      // }
      this.$api.shared.anchor = "nope";
      this.$nextTick(() => {
        this.$api.shared.anchor = v;
      });
    },
  },
  computed: {},
  watch: {},
  validations() {
    return {
      evaluating: {
        $each: {
          id: {
            required,
          },
          role_id: {
            required,
          },
        },
      },
    };
  },
};
</script>
<style lang="css">
.main-content.feedback {
  width: 60%;
}
.buttons {
  display: flex;
  justify-content: flex-end;
}
.white-button {
  margin-right: 1rem;
}
.save-button {
  width: fit-content;
  cursor: pointer;
}
a.button {
  height: 30px;
}
.menu-item {
  /* padding: 0 !important; */
  text-transform: none;
}
.question-box {
  width: 80%;
}
.center .range-slider {
  width: 100%;
}
.center {
  display: block;
  width: 100%;
  text-align: center;
}
.input-box {
  align-items: center;
}
.switch {
  width: 20%;
  text-align: right;
}
.input {
  font-size: 0.8rem;
  width: 100%;
}
.input textarea {
  font-size: 0.8rem;
  width: 100%;
  max-width: 100%;
  height: 40px;
  min-height: 25px;
  max-height: 150px;
  float: left;
  resize: vertical;
}
.inactive {
  color: grey;
}
.inactive textarea {
  resize: none;
}
@media (max-width: 560px) {
  .buttons {
    flex-direction: column;
    align-items: center;
  }
  .white-button {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/Feedback.vue